import React from "react"
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import { makeStyles } from '@material-ui/core/styles'
// import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { ConfirmDialog } from '../confirmDialog'


const useStyles = makeStyles({
    root: {
      minWidth: 300,
      maxWidth: 650
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)'
    },
    title: {
      fontSize: 14
    },
    pos: {
      marginBottom: 12
    }
  })

export const AppAmbAssocCard = ({ associationData, currentAssoc, dialogOpen, handleDialog  }) => {

  if (!associationData) {
    return <div className="App-w-100" />
  }
  const classes = useStyles()

  return (
    <div className="App-w-100 ">
    <Card className={classes.root} variant="outlined">
    <CardContent>
    <Typography
      className={classes.title}
      color="textSecondary"
      gutterBottom>
        {associationData.Acronym}
      </Typography>
      <Typography variant="h5" component="h2">
       {associationData.Title}
      </Typography>
      { (associationData) ? (
          <div>
        <Typography
      className={classes.title}
      color="textSecondary"
      gutterBottom>
        AMBASSADOR ASSOCIATION CONTACT
      </Typography>
      <Typography variant="h5" component="h4">
       {associationData.Staff_x0020_Contact}
      </Typography>
      <Typography variant="body2" component="p">
        Email: {associationData.Email}
        <br />
        Phone: {associationData.Phone_x0020_Number}
        <br />
        {
            associationData.Fax ?
            (<span>Fax: {associationData.Fax} <br /></span>) : (<span />)
        }
        Address:<br />
        {associationData.Address_x0020_Line1}
        <br />
        {
            associationData.Address_x0020_Line2 ?
            (<span>{associationData.Address_x0020_Line2} <br /></span>) : (<span />)
        }
        {
            associationData.City ?
            (<span>{associationData.City} <br /></span>) : (<span />)
        }
        {
            associationData.State ?
            (<span> {associationData.State} </span>) : (<span />)
        }
        {
            associationData.Country ?
            (<span> / {associationData.Country} <br /></span>) : (<span />)
        }
      </Typography>
      </div>) : (<br />)}
      <br />
      <Typography
      className={classes.pos}
      color="textSecondary">
        Affiliated with:
      </Typography>
      <ul>
        {
            associationData.worksWith.map(assoc =>
            <li
            key={assoc.ID}
            className="ambassador-lnk"
            onClick={() => {handleDialog(assoc)}}>{assoc.Title}</li>)
        }
      </ul>
    </CardContent>
    <CardActions>
    </CardActions>
  </Card>
  <ConfirmDialog
  associationData={currentAssoc}
  open={dialogOpen}
  onClose={handleDialog} />
  </div>
  )
}
